import { render, staticRenderFns } from "./ConceptosCRUD.vue?vue&type=template&id=3b84d644"
import script from "./ConceptosCRUD.vue?vue&type=script&lang=js"
export * from "./ConceptosCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports